interface JwtPayload {
  sessionId?: string;
}

export function decodeSessionIdFromToken(token: string): string | null {
  try {
    const parts = token.split('.');
    if (parts.length < 2) {
      return null;
    }
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64)) as JwtPayload;
    return payload.sessionId ?? null;
  } catch {
    return null;
  }
}
